// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1d75be2a","156":"e2a8081b","409":"5d8cb543","849":"b700f61b"}[chunkId] + ".chunk.js";
};